import { render, staticRenderFns } from "./Tail.vue?vue&type=template&id=7dec5535&scoped=true&"
import script from "./Tail.vue?vue&type=script&lang=js&"
export * from "./Tail.vue?vue&type=script&lang=js&"
import style0 from "./Tail.vue?vue&type=style&index=0&id=7dec5535&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dec5535",
  null
  
)

export default component.exports